export default {
  methods: {
    capitalizeText(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    thumbnail(value) {
      if (!value) {
        return undefined
      }
      if (value && value === '') {
        return ''
      }
      let filename = value.split('/').pop()
      return `//d13q3jz1cdlk7q.cloudfront.net/dev/400x400/${filename}`
    },
    fullwidth(value) {
      if (!value) {
        return undefined
      }
      if (value && value === '') {
        return ''
      }
      let filename = value.split('/').pop()
      return `//d13q3jz1cdlk7q.cloudfront.net/dev/1920x1080/${filename}`
    },
    toSnakeCaps(item) {
      if (!item) return ''
      const str = item.toString()
      return str
        .trim()
        .replace(/ /g, '_')
        .replace(/[^\w\s]/gi, '')
        .toUpperCase()
    },
    generateFileName(media, episode) {
      // TODO: account for movies

      const name = `${this.toSnakeCaps(episode.id)}_${this.toSnakeCaps(
        media.metadata.suppliers && media.metadata.suppliers[0]
          ? media.metadata.suppliers[0].replace(/ /g, '')
          : ''
      )}_${this.toSnakeCaps(media.title)}_${this.toSnakeCaps(
        media.mediadata.seriesNo
      ).padStart(2, '0')}_${this.toSnakeCaps(episode.episode_number).padStart(
        4,
        '0'
      )}_${this.toSnakeCaps(
        media.metadata.resolutions && media.metadata.resolutions[0]
          ? media.metadata.resolutions[0]
          : ''
      )}`
      return name
    }
  }
}
